export var JourneyGroupType;
(function (JourneyGroupType) {
    JourneyGroupType["Monthly"] = "Monthly";
    JourneyGroupType["UpNext"] = "UpNext";
    JourneyGroupType["LastWeek"] = "LastWeek";
    JourneyGroupType["FoodAndDrink"] = "FoodAndDrink";
})(JourneyGroupType || (JourneyGroupType = {}));
